import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { DocumentDetailsModalContainer } from '@/features/documents/DocumentDetailsModal/DocumentDetailsModalContainer'
import { DeleteDocumentDialogContainer } from '@/features/documents/DeleteDocumentDialog/DeleteDocumentDialogContainer'
import { UnlinkDocumentDialogContainer } from '@/features/documents/UnlinkDocumentDialog/UnlinkDocumentDialogContainer'

export default observer(function Inner() {
  const { documents } = useFeatures((r) => ({
    documents: r.documents.internal(),
  }))
  const detailsVm =
    documents.documentDetailsRootViewModel.selectedDocDetailsModalVm

  return (
    <>
      {detailsVm && <DocumentDetailsModalContainer vm={detailsVm} />}
      <DeleteDocumentDialogContainer
        vm={documents.deleteDocumentDialogViewModel}
      />
      <UnlinkDocumentDialogContainer
        vm={documents.unlinkDocumentDialogViewModel}
      />
    </>
  )
})
